module.exports = __webpack_public_path__ + "images/emoji/heart_eyes_cat.44fa3424a09cb5957ec2.png";